<template>
  <div class="body workorder-field-list">
    <div class="left-area flex-valign">
      <div class="header">
        <span class="title">字段类型选择</span>
      </div>
      <!-- <div class="btn-list flex-auto"> -->
      <el-scrollbar class="btn-list flex-auto scroll-bar">
        <template v-for="(col, index) in columnList">
          <el-button
            class="option-btn"
            :key="index"
            type="primary"
            @click="addField(col)"
            >{{ col.defaultName }}</el-button
          >
        </template>
      </el-scrollbar>
      <!-- </div> -->
    </div>
    <div class="right-area flex">
      <div class="full-width flex-center">
        <!-- <span class="title">{{$t('workOrder.title.fields')}}</span> -->
        <el-tabs v-model="activeFieldName" style="display: flex">
          <el-tab-pane
            :label="
              workOrderType == 2 || workOrderType == 3
                ? '创建人字段编辑'
                : '提交人字段编辑'
            "
            name="submiter"
          ></el-tab-pane>
          <el-tab-pane
            v-if="workOrderType == 2 || showWork"
            :label="
              workOrderType == 2 || workOrderType == 3
                ? '违规人字段编辑'
                : '执行人字段编辑'
            "
            name="executor"
          ></el-tab-pane>
          <div style="padding: 7px" v-if="workOrderType != 2">
            <el-button
              type="text"
              v-if="!showWork"
              icon="el-icon-plus"
              @click="updateWork(1)"
            ></el-button>
            <el-button
              type="text"
              v-if="showWork"
              icon="iconfont icon-shanchu"
              @click="updateWork(0)"
            ></el-button>
          </div>
        </el-tabs>
      </div>
      <div class="field-show mt20 flex">
        <el-scrollbar class="scroll-bar">
          <draggable v-model="fieldList" @end="dragEnd">
            <div
              class="field-item pointer"
              :class="{ active: index === activeFieldIndex }"
              v-for="(field, index) in fieldList"
              :key="index"
              @click="showProps(field, index)"
            >
              <el-row v-if="false">
                <el-col :span="4">
                  <div class="field-name col-height">
                    <span>{{ field.fieldName }}：</span>
                  </div>
                </el-col>
                <el-col :span="20">
                  <div class="field-value col-height">
                    <span>{{ field.placeholder }}</span>
                    <el-button
                      type="text"
                      icon="iconfont icon-shanchu"
                      @click.stop="deleteField(index)"
                    ></el-button>
                  </div>
                </el-col>
              </el-row>
              <el-row class="field-line" style="word-break: break-all">
                <el-col :span="1" class="flex-center">
                  <!-- <el-button type="text"
                             icon="iconfont icon-shanchu"
                             @click.stop="deleteField(index)"></el-button> -->
                </el-col>
                <el-col :span="5">
                  <div
                    class="field-name col-height"
                    :class="{ required: field.required }"
                  >
                    <span>{{ field.fieldName }}：</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div
                    v-if="
                      (field.type === 1 && field.rowType === 1) ||
                      field.type === 2 ||
                      field.type === 3
                    "
                    class="flex-layout"
                    style="padding: 10px"
                  >
                    <el-input
                      style="color: #fff"
                      disabled
                      :type="field.numberType === 1 ? 'number' : 'text'"
                      :placeholder="field.placeholder"
                      v-model="field.fieldValue"
                    >
                      <template
                        v-if="field.unitPosition === 1 && field.unit"
                        slot="prepend"
                        >{{ field.unit }}</template
                      >
                      <template
                        v-if="field.unitPosition === 2 && field.unit"
                        slot="append"
                        >{{ field.unit }}</template
                      >
                    </el-input>
                  </div>
                  <div
                    v-if="field.type === 1 && field.rowType === 2"
                    class="flex-layout"
                  >
                    <el-input
                      type="textarea"
                      class="margin10"
                      disabled
                      :placeholder="field.placeholder"
                      v-model="field.fieldValue"
                      rows="5"
                      resize="none"
                    ></el-input>
                  </div>
                  <div v-else-if="field.type === 4">
                    <el-date-picker
                      style="width: calc(100% - 20px)"
                      class="margin10"
                      disabled
                      :type="field.dateType === 1 ? 'date' : 'datetime'"
                      :placeholder="
                        field.placeholder || '请选择' + field.fieldName
                      "
                      value-format="yyyy-MM-dd HH:mm:ss"
                      v-model="field.fieldValue"
                    ></el-date-picker>
                  </div>
                  <div
                    v-else-if="field.type === 5 && field.showType === 1"
                    class="flex-layout"
                  >
                    <el-select
                      class="margin10"
                      style="flex: 1"
                      disabled
                      v-if="field.optionName"
                      v-model="field.fieldValue"
                      :multiple="field.selectType === 2"
                      :placeholder="
                        field.placeholder || '请选择' + field.fieldName
                      "
                    >
                      <el-option
                        v-for="(item, i) in field.valueList"
                        :key="i"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </div>
                  <div
                    v-else-if="
                      field.type === 5 &&
                      field.showType === 2 &&
                      field.optionName
                    "
                    class="flex-layout"
                  >
                    <el-radio-group
                      class="margin10"
                      disabled
                      v-if="field.selectType === 1"
                      v-model="field.fieldValue"
                    >
                      <el-radio
                        :label="item"
                        v-for="(item, i) in field.valueList"
                        :key="i"
                      ></el-radio>
                    </el-radio-group>
                    <el-checkbox-group
                      class="margin10"
                      disabled
                      v-if="field.selectType === 2"
                      v-model="field.fieldValue"
                    >
                      <el-checkbox
                        :label="item"
                        v-for="(item, i) in field.valueList"
                        :key="i"
                      ></el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <div v-else-if="field.type === 6">
                    <location
                      class="margin10"
                      v-model="field.fieldValue"
                      disabled
                    ></location>
                  </div>
                  <div v-else-if="field.type === 7">
                    <el-upload
                      action
                      class="margin10"
                      :show-file-list="true"
                      :list-type="'picture-card'"
                      :accept="'image/png, image/jpg, image/jpeg, image/bpm'"
                      :auto-upload="false"
                      disabled
                      :limit="1"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </div>
                  <div v-else-if="field.type === 8">
                    <el-upload
                      action
                      class="margin10"
                      :show-file-list="true"
                      :list-type="'picture-card'"
                      :auto-upload="false"
                      disabled
                      :limit="1"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </div>
                  <div v-else-if="field.type === 9 || field.type === 11">
                    <choose-area
                      v-model="field.fieldValue"
                      disabled
                    ></choose-area>
                  </div>
                  <div v-else-if="field.type === 10">
                    <!-- <choose-person :multiCheck="false" v-model="field.fieldValue" title="消息通知人员"></choose-person> -->
                    <choose-notice
                      :placeholder="
                        field.placeholder || '请选择' + field.fieldName
                      "
                      disabled
                    ></choose-notice>
                  </div>
                  <div v-else-if="field.type === 12" class="flex-layout">
                    <el-input
                      type="text"
                      class="margin10"
                      disabled
                      :placeholder="field.placeholder"
                      v-model="field.fieldValue"
                      s
                    ></el-input>
                  </div>
                  <div class="fieldBtn">
                    <el-button type="text" title="按住鼠标拖动">
                      <i class="el-icon-rank"></i>
                    </el-button>
                    <!-- <el-button type="text"
                               @click.stop="addField(field)"
                               title="点击复制">
                      <i class="el-icon-copy-document"></i>
                    </el-button> -->
                    <el-button
                      type="text"
                      title="删除"
                      @click.stop="deleteField(index)"
                    >
                      <i class="el-icon-delete"></i>
                    </el-button>
                  </div>
                </el-col>
              </el-row>
            </div>
          </draggable>
        </el-scrollbar>
      </div>
      <div class="footer">
        <el-button type="primary" :loading="saveBtn" @click.stop="save()">
          {{ saveBtn ? "保存中..." : $t("workOrder.button.save") }}
        </el-button>
        <el-button type="info" :loading="saveBtn" @click.stop="cancel()">
          取消
        </el-button>
      </div>
    </div>
    <div class="third-area flex-valign">
      <div class="header">
        <span class="title">字段详情配置</span>
      </div>
      <el-scrollbar class="scroll-bar flex-auto">
        <field-props
          :workOrderType="workOrderType"
          v-model="fieldDetail"
        ></field-props>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import { api } from "../api";
import getData from "../option/fieldData";
import fieldProps from "./field-props";
import utils from "@src/common/utils";
import ChooseArea from "../components/choose-area";
// import ChoosePerson from "../components/choose-person";
import ChooseNotice from "../components/choose-notice";
import location from "./location";
import draggable from "vuedraggable";
export default {
  name: "field-list",
  props: {},
  components: {
    fieldProps,
    ChooseArea,
    location,
    draggable,
    // ChoosePerson,
    ChooseNotice,
  },
  data() {
    return {
      showWork: false,
      workOrderType: 0,
      executorFlag: 0,
      activeFieldName: "submiter",
      columnList: getData(), // 字段类型列表
      activeFieldIndex: -1,
      fieldList: [], // 当前模板的字段数据（转换后）
      dataList: [], // 当前模板的字段数据（转换前的，接口获取到的）
      deleteList: [],
      templateCode: "",
      fieldDetail: {},
      saveBtn: false,
    };
  },
  computed: {
    submitList() {
      /**
       * 带fieldcode为要删除的字段
       * 不带code为新增的字段
       * 已有的不改的字段需要过滤掉
       */
      // let list = this.fieldList.filter((field) => {
      //   return !field.fieldCode;
      // });
      let list = this.fieldList;
      let addList = list.map((item) => {
        return {
          fieldName: item.fieldName,
          type: item.type,
          fieldCode: item.fieldCode || "", //存在的是旧数据，不存在的是add
          info: this.convertInfo(item),
        };
      });
      // return addList.concat(this.deleteList);
      return addList;
    },
  },
  watch: {
    activeFieldName: {
      handler(newVal, oldVal) {
        this.switchFieldName(newVal, oldVal);
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.fieldData = {
      submiter: {
        fieldList: [],
        dataList: [],
        deleteList: [],
        fieldDetail: {},
        activeFieldIndex: -1,
      },
      executor: {
        fieldList: [],
        dataList: [],
        deleteList: [],
        fieldDetail: {},
        activeFieldIndex: -1,
      },
    };
  },
  mounted() {
    this.fieldTypeMap = {
      submiter: 1,
      executor: 2,
    };
    if (this.$route.query && this.$route.query.workOrderType) {
      this.workOrderType = this.$route.query.workOrderType;
      this.executorFlag = this.$route.query.executorFlag;
      this.showWork = this.executorFlag == 1 ? true : false;
    }
    if (this.$route.query && this.$route.query.templateCode) {
      this.templateCode = this.$route.query.templateCode;
      this.queryWorkOrderFieldList();
    }
    // if (this.workOrderType == 2 || this.workOrderType == 3 || this.workOrderType == 5) {
    //   this.columnList.splice(8, 1)
    // }
  },
  methods: {
    dragEnd(evt) {
      this.activeFieldIndex = evt.newIndex;
    },
    // 新增,删除执行人
    updateWork(flag) {
      this.$fetch(api.workOrder.updateWorkOrderTemp, {
        executorFlag: flag,
        templateCode: this.templateCode,
      }).then((res) => {
        if (res.success) {
          this.showWork = !this.showWork;
          this.activeFieldName = "submiter";
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    switchFieldName(newVal, oldVal) {
      if (this.fieldData) {
        if (oldVal) {
          this.fieldData[oldVal] = {
            fieldList: this.fieldList,
            dataList: this.dataList,
            deleteList: this.deleteList,
            fieldDetail: this.fieldDetail,
            activeFieldIndex: this.activeFieldIndex,
          };
        }
        if (newVal && this.fieldData[newVal]) {
          if (
            this.fieldData[newVal].dataList &&
            this.fieldData[newVal].dataList.length
          ) {
            this.fieldList = this.fieldData[newVal].fieldList || [];
            this.dataList = this.fieldData[newVal].dataList || [];
            this.deleteList = this.fieldData[newVal].deleteList || [];
            this.fieldDetail = this.fieldData[newVal].fieldDetail || {};
            this.activeFieldIndex = this.fieldData[newVal].activeFieldIndex;
          } else {
            this.queryWorkOrderFieldList();
          }
        }
      }
    },
    queryWorkOrderFieldList() {
      this.fieldList = [];
      this.deleteList = [];
      this.fieldDetail = {};
      this.activeFieldIndex = -1;
      this.$fetch(api.workOrder.queryWorkOrderFieldList, {
        flowType: this.fieldTypeMap[this.activeFieldName],
        templateCode: this.templateCode,
      }).then((res) => {
        if (res.success) {
          this.dataList = res.returnObj;
          this.convertField();
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    convertField() {
      /**
       * 需要将接口获取到的字段其他属性info转换成本地配置的格式
       * 方便页面展示用
       */
      this.dataList.forEach((data) => {
        this.columnList.some((col) => {
          if (Number(data.type) === col.type) {
            const obj = utils.setFieldData({ ...col }, data);
            this.fieldList.push({ ...obj });
            return true;
          }
        });
      });
    },
    addField(col) {
      console.log(col);
      let field = Object.assign({}, col);
      field.fieldName = field.defaultName;
      if (field.type === 5) {
        field.valueList = [];
        field.colorList = [];
      }
      this.fieldList.push(field);
      console.log(this.fieldList);
    },
    deleteField(index) {
      if (this.fieldList[index].fieldCode) {
        this.deleteList.push({ ...this.fieldList[index] });
      }
      this.fieldList.splice(index, 1);
      this.fieldDetail = {};
    },
    showProps(field, index) {
      this.activeFieldIndex = index;
      console.log(field);
      this.fieldDetail = field;
    },
    save() {
      this.saveBtn = true;
      const params = {
        flowType: this.fieldTypeMap[this.activeFieldName],
        templateCode: this.templateCode,
        workOrderFieldList: this.submitList,
      };
      this.$fetch(api.workOrder.updateWorkOrderField, params).then((res) => {
        setTimeout(() => {
          this.saveBtn = false;
        }, 300);
        if (res.success) {
          this.$message.success("字段信息保存成功");
          this.queryWorkOrderFieldList();
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    cancel() {
      this.$router.go(-1);
    },
    getFieldList() {
      let list = this.fieldList.filter((field) => {
        return !field.fieldCode;
      });
      return list.map((item) => {
        return {
          fieldName: item.fieldName,
          type: item.type,
          info: this.convertInfo(item),
        };
      });
    },
    convertInfo(item) {
      console.log(item);
      /**
       * 将其他属性转换成info以“；”分隔
       */
      let arr = [];
      // 排除info以外的属性
      const exclude = [
        "type",
        "defaultName",
        "fieldName",
        "fieldValue",
        "extendInfo",
        "fieldCode",
        "valueList",
        "colorList",
      ];
      for (const key in item) {
        if (item.hasOwnProperty(key)) {
          // const element = item[key];
          if (exclude.indexOf(key) === -1) {
            arr.push(item[key]);
          }
        }
      }
      return arr.join(";");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.col-height {
  line-height: 35px;
}
.pointer {
  &:active {
    cursor: pointer;
    // @include set_theme_color(background-color, menu-tab-bg-color);
    // color: red;
    // @include set_theme_color(color, menu-tab-bg-color);
  }
}
</style>